import createApiService from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";
import { TOrderFormData } from "@modules/order/models/orderForm";
import mapOrderToShipmentRequest from "@modules/order/utils/mapOrderToShipmentRequest";

const validateFromAddressService = createApiService({
  method: "GET",
  url: API_ROUTES.GEOROUTING_CHECK_FROM_ADDRESS,
  allowedErrStatus: 429,
});

const validateToAddressService = createApiService({
  method: "GET",
  url: API_ROUTES.GEOROUTING_CHECK_TO_ADDRESS,
  allowedErrStatus: 429,
});

export const checkGeoroutingAvailability = async (
  addressType: "from" | "to",
  order: TOrderFormData
) => {
  const service = addressType === "from" ? validateFromAddressService : validateToAddressService;
  const mappedData = mapOrderToShipmentRequest(order);

  return await service({ params: mappedData as any });
};
